import { Info } from 'lucide-react'
import { HoverTooltip } from '@/components/ui/HoverTooltip'

export function InfoTooltip({
  content,
  className,
}: {
  content?: React.ReactNode
  className?: string
}) {
  return (
    <HoverTooltip content={content} className={className}>
      <Info className={`h-4 w-4 text-muted-foreground cursor-help ${className || ''}`} />
    </HoverTooltip>
  )
}
